import React, { useState } from 'react';
import { EncountersTrackerContext } from "./EncountersTrackerContext";

function EncountersTrackerProvider({children}) {
    const [encounters, setEncounters] = useState([]);

    const trackEncounters = enctrs => {
        // Currently we need to track only id and general status
        // of each encounter.
        const newEncounters = enctrs.map(
          ({ id, generalStatusDisplay, code, generalStatus }) => 
            ({ id, generalStatusDisplay, generalStatus, code })
        );
        setEncounters(newEncounters);
    };

    return (
        <EncountersTrackerContext.Provider value={{
            trackedEncounters: encounters,
            trackEncounters
        }}>
            {children}
        </EncountersTrackerContext.Provider>
    )
}

export default EncountersTrackerProvider;